import defaultReducer from './defaultReducer' ;
import { defaultGrid } from '../../helpers/datagrid';


export default defaultReducer(
    'COLLECTION_MODAL', 
    { 
        title: "Collection Week Banking", 
        open: false, 
        isPerformance: false,
        detailGrid: defaultGrid,
        summaryGrid: defaultGrid,
        categoryGrid: defaultGrid,
        siteFloatGrid: defaultGrid,
        kioskGrid: defaultGrid,
        optionShowViewCommentsButton: false,
        siteText: "",
        weekText: "",
    }
)
